  function waitForCustomerReferralLoaded(a, b = 100) {
  const c = setInterval(function () {
    "undefined" != typeof uppromoteCustomerReferral && (a(), clearInterval(c));
  }, b);
  setTimeout(function () {
    clearInterval(c);
  }, 5e3);
}
function waitElementLoaded(a, b, c = 100) {
  const d = setInterval(function () {
    const c = document.querySelector(a);
    c && (b(), clearInterval(d));
  }, c);
  setTimeout(function () {
    clearInterval(d);
  }, 5e3);
}
const customerReferralItemSelector = `#sca_customer_refer_email`; // Cái selector này lúc đó phải dò ở shop khách xem là gì để thay đổi tương ứng cho hợp lý nhá
waitElementLoaded(customerReferralItemSelector, function () {
  waitForCustomerReferralLoaded(function () {
    // trong này là widget customer refer đã được load ở shop khách
    document.getElementById('sca_customer_refer_email').placeholder = 'Deine E-Mail Adresse';
  });
});

const customerReferralItemSelectorButton = `.sca_aff_customer_refer_invite_button`;
waitElementLoaded(customerReferralItemSelectorButton, function () {
  waitForCustomerReferralLoaded(function () {
    const buttons = document.querySelectorAll('.sca_aff_customer_refer_invite_button');
    buttons.forEach(button => {
      button.style.textAlign = "center";
    });
  });
});

const customerReferralItemSelectorContent = `.sca_aff_customer_refer_invite_content`;
waitElementLoaded(customerReferralItemSelectorContent, function () {
  waitForCustomerReferralLoaded(function () {
    var contents = document.querySelectorAll('.sca_aff_customer_refer_invite_content');
    contents.forEach(function(content) {
        var html = content.innerHTML;
        var newHtml = html.replace(/(10%)/g, '<span class="highlight">$1</span>');
        content.innerHTML = newHtml;
    });
    var highlights = document.querySelectorAll('.highlight');
    highlights.forEach(function(highlight) {
        highlight.style.fontWeight = '900';
    });
  });
});


